import type { IRootState } from 'store'

/**
 * Who may upload a policy PDF: every signed-in user, in every environment.
 *
 * Kept as one rule read straight off the store, so the three places that offer an upload —
 * the dashboard dropzone, the empty column header and the chat popover — cannot drift
 * apart on who is allowed one, and there is a single place to narrow it again.
 */
export function canUserUploadPolicyPdf(state: IRootState): boolean {
  return Boolean(state?.auth?.account)
}
